import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import './OrderSuccessPage.css';

const OrderSuccessPage = () => {
    // URL parameters se order id fetch karne ke liye
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get('id') || 'N/A';

    return (
        <div className="success-container">
            <div className="success-card">
                {/* Animated Green Check Matrix Success Icon */}
                <div className="success-icon-wrapper">
                    <div className="success-icon-circle">
                        <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                            <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none" />
                            <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                        </svg>
                    </div>
                </div>

                <h1 className="success-title">Order Placed Successfully!</h1>
                <p className="success-message">
                    Thank you for shopping with <strong>RBuyMart</strong>. Your order execution matrix has been verified and processed by our servers.
                </p>

                {/* Dynamic Order Metadata Badge Box */}
                <div className="order-badge-box">
                    <span className="badge-label">ORDER ID</span>
                    <span className="badge-value">#RBM-{orderId}</span>
                </div>

                <div className="timeline-info-card">
                    <div className="info-row">
                        <span className="info-dot green"></span>
                        <p>A confirmation email and SMS updates will be sent to your registered contact shortly.</p>
                    </div>
                    <div className="info-row">
                        <span className="info-dot blue"></span>
                        <p>Our logistics matrix system is preparing your parcel dispatch queue parameters.</p>
                    </div>
                </div>

                {/* Navigation Actions Panel */}
                <div className="success-actions-group">
                    <Link to="/myorder" className="btn-action-primary">
                        📦 Track Order Status
                    </Link>
                    <Link to="/shop" className="btn-action-secondary">
                        🛒 Continue Shopping
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default OrderSuccessPage;